<template>
  <Screen>
    <AppBar
      title="Manage meditation tracks"
      :description="`Add or update BIBO app meditation track formarly known as guided meditation`"
      :showBackButton="false"
    >
      <inertia-link
        :href="$route('admin.blissdom.guidedmeditation.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Meditation tracks" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <div class="table-responsive" v-if="data.data.length > 0">
          <table class="table mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Sort order</th>
                <th>Status</th>
                <th>Premium</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.data" :key="item.id">
                <td>
                  {{
                    i + 1 + (data.meta.current_page - 1) * data.meta.per_page
                  }}
                </td>
                <td>
                  <img
                    v-lazy="item.thumbnail"
                    :alt="item.title"
                    class="preview-img-sm"
                    width="100"
                    height="100"
                    style="background-color: #f1f1f1"
                  />
                </td>
                <th>
                  <div class="mb-2">{{ item.title }}</div>
                  <a
                    :href="item.audio"
                    class="btn btn-primary btn-sm"
                    target="_blank"
                  >
                    <i class="fa fa-play-circle mr-1"></i>
                    <span>Play</span>
                  </a>
                </th>
                <td>{{ item.sort_order }}</td>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.isactive"
                    action="guidedMeditationStatus"
                  />
                </th>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.is_premium"
                    labelText="Premium/Free"
                    action="guidedMeditationPremiumStatus"
                  />
                </th>
                <td>{{ item.created_at_human || "-" }}</td>
                <td>{{ item.updated_at_human || "-" }}</td>
                <td>
                  <inertia-link
                    class="btn btn-sm btn-light"
                    :href="
                      $route('admin.blissdom.guidedmeditation.edit', {
                        id: item.id,
                      })
                    "
                  >
                    Update
                  </inertia-link>
                  <button
                    @click.prevent="deleteThis(item.id)"
                    class="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <NoData title="No meditation tracks added yet" v-else>
          <inertia-link
            :href="$route('admin.blissdom.guidedmeditation.create')"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Add new
          </inertia-link>
        </NoData>
        <Pagination :rawData="data.meta" :onClick="pageChange" />
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    async deleteThis(id) {
      this.$root.$emit("confirmModal", {
        title: "Do you want to delete this meditation track?",
        message: "You won't be able to revert this!",
        confirmText: "Yes, delete it!",
        onConfirm: () => {
          this.$root.$emit("hold-transition", null);
          this.$inertia.delete(
            this.$route("admin.blissdom.guidedmeditation.delete", {
              id: id,
            })
          );
        },
      });
    },
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
  },
  computed: {},
};
</script>
